import { render, staticRenderFns } from "./cates.vue?vue&type=template&id=4813f880&scoped=true"
import script from "./cates.vue?vue&type=script&lang=js"
export * from "./cates.vue?vue&type=script&lang=js"
import style0 from "./cates.vue?vue&type=style&index=0&id=4813f880&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4813f880",
  null
  
)

export default component.exports